import { useEffect, useState } from 'react'
import services from '../../services'

/** A busca no texto das conversas só começa com 3 letras (o servidor repete a regra). */
export const MIN_LETRAS_DA_CONVERSA = 3

const VAZIO: ReadonlySet<number> = new Set<number>()

/**
 * Os números das solicitações cuja conversa tem o que a pessoa digitou. Espera ela parar de digitar e só devolve
 * o resultado do que está no campo agora (nunca o da digitação anterior). Falhou ou é curto: conjunto vazio.
 */
export function useBuscaNasConversas(busca: string, todas: boolean, compartilhadas = false, atraso = 400): ReadonlySet<number> {
  const termo = busca.trim().replace(/^#/, '')
  const [achados, setAchados] = useState<{ termo: string; todas: boolean; compartilhadas: boolean; ids: ReadonlySet<number> }>({ termo: '', todas: false, compartilhadas: false, ids: VAZIO })

  useEffect(() => {
    if (termo.length < MIN_LETRAS_DA_CONVERSA) return undefined
    let vivo = true
    const espera = setTimeout(async () => {
      let ids = VAZIO
      try {
        const r = compartilhadas ? await services.api.solicitacoesBuscarConversas(termo, todas, true) : await services.api.solicitacoesBuscarConversas(termo, todas)
        if (!r.fail && Array.isArray(r.data)) ids = new Set<number>(r.data)
      } catch { /* sem a busca na conversa, vale o resto */ }
      if (vivo) setAchados({ termo, todas, compartilhadas, ids })
    }, atraso)
    return () => { vivo = false; clearTimeout(espera) }
  }, [termo, todas, compartilhadas, atraso])

  return achados.termo === termo && achados.todas === todas && achados.compartilhadas === compartilhadas && termo.length >= MIN_LETRAS_DA_CONVERSA ? achados.ids : VAZIO
}
